export default "/_next/static/chunks/fonts/Source Sans Pro Bold-751d4a14f36df3f4d63c274853c8d60b.otf";